import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../components/Layout/layout";
import RequestListContainer from "../requestList";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "../../../Auth/components/ProtectedRoute";

const Requests = props => (
  <ProtectedRoute>
    <main>
    <Helmet title="Requests" />
    <Layout>
      <Routes>
        <Route path="/" element={<RequestListContainer />} />
      </Routes>
    </Layout>
    </main>
  </ProtectedRoute>
);

export default Requests;
